/* eslint-disable no-unused-vars */
import { FC, ReactNode } from "react";
import { FormItem, Select } from "formik-antd";

import { Styles } from "../styled";
import { useConfirmingLeave } from "@lhd/app/index";

type OmittedTagValue = { label?: ReactNode; value?: string | number };

type IProps = {
  name: string;
  label?: string;
  className?: string;
  selectClassName?: string;
  required?: boolean;
  options: {
    label: string;
    value: number | string;
  }[];
  loading?: boolean;
  multiple?: boolean;
  placeholder?: string;
  defaultValue?: string | number | (string | number)[];
  value?: string | number | (string | number)[] | null;
  error?: string;
  disabled?: boolean;
  allowClear?: boolean;
  isLeaveForm?: boolean;
  onChange?: (e: any, option?: any) => void;
  setFieldValue?: (field: string, value: any) => void;
  showSearch?: boolean;
  suffixIcon?: any;
  mode?: "multiple" | "tags";
  boldLabel?: boolean;
  /** Multiple: one row when closed; overflow as +N (rc-select) */
  maxTagCount?: number | "responsive";
  maxTagPlaceholder?:
    | ReactNode
    | ((omittedValues: OmittedTagValue[]) => ReactNode);
  onDropdownVisibleChange?: (open: boolean) => void;
  dropdownClassName?: string;
  /** Override Select filter (omit = default substring match on option children text) */
  filterOption?:
    | boolean
    | ((input: string, option: Record<string, any> | undefined) => boolean);
  labelInValue?: boolean;
};

const { Option } = Select;

const SelectField: FC<IProps> = ({
  name,
  label,
  className,
  selectClassName,
  required = false,
  loading = false,
  placeholder = "",
  options = [],
  multiple,
  error,
  allowClear = true,
  disabled = false,
  onChange,
  defaultValue,
  value,
  isLeaveForm = false,
  showSearch = true,
  suffixIcon = undefined,
  mode,
  boldLabel = false,
  maxTagCount,
  maxTagPlaceholder,
  onDropdownVisibleChange,
  dropdownClassName,
  filterOption: filterOptionProp,
  labelInValue = false,
}) => {
  const { checkLeaveForm } = useConfirmingLeave();
  return (
    <Styles className="select" isLabelBold={boldLabel}>
      <FormItem
        name={name}
        className={className}
        label={label}
        required={required}
      >
        <Select
          allowClear={allowClear}
          disabled={disabled}
          showSearch={showSearch}
          mode={mode}
          labelInValue={labelInValue}
          {...(suffixIcon !== undefined ? { suffixIcon } : {})}
          optionFilterProp="label"
          {...(filterOptionProp !== undefined
            ? { filterOption: filterOptionProp }
            : {})}
          {...(error && { status: "error" })}
          notFoundContent="データがありません。"
          placeholder={placeholder}
          className={selectClassName}
          showArrow
          loading={loading}
          name={name}
          onChange={(e: any, option) => {
            onChange && onChange(e, option);
            isLeaveForm && checkLeaveForm();
          }}
          {...(multiple && {
            mode: "multiple",
          })}
          {...(maxTagCount !== undefined ? { maxTagCount } : {})}
          {...(maxTagPlaceholder !== undefined ? { maxTagPlaceholder } : {})}
          {...(onDropdownVisibleChange ? { onDropdownVisibleChange } : {})}
          {...(dropdownClassName ? { dropdownClassName } : {})}
          {...(defaultValue ? { defaultValue } : {})}
          {...(value !== undefined ? { value } : {})}
        >
          {options?.map((item) => (
            <Option value={item.value} key={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
        </Select>
        {error && <p className="error-message">{error}</p>}
      </FormItem>
    </Styles>
  );
};

export default SelectField;
